import React from "react";

export const CopyrightWidgetLoading = props => {
    let className = 'text-small text-white '
    if (typeof props.className !== 'undefined') {
        className += props.className;
    }
    
    return (
        <div style={{
            textAlign: props.textAlign,
        }} className={className}>
            {typeof props.begin !== 'undefined' && props.begin < props.year
                ? (
                    <>&copy; {props.begin} - {props.year} American Urological Association. All Rights Reserved.</>
                )
                : (
                    <>&copy; {props.year} American Urological Association. All Rights Reserved.</>
                )
            }
            
        </div>
    );
};
